import { gql } from '@apollo/client';
import { MUTATION_ERROR_FRAGMENT } from '@graphql/fragments/mutationErrorFragment';
import { ORGANIZATION_FRAGMENTS } from '@graphql/fragments/organizationFragment';

export const CREATE_ORGANIZATION_MUTATION = gql`
  mutation CreateOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      organization {
        ...OrganizationFields
      }
    }
  }
  ${ORGANIZATION_FRAGMENTS}
`;

export const ONBOARD_ORGANIZATION_MUTATION = gql`
  mutation OnboardOrganization($input: OnboardOrganizationInput!) {
    onboardOrganization(input: $input) {
      organization {
        ...OrganizationFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ORGANIZATION_FRAGMENTS}
`;

export const UPDATE_ORGANIZATION_MUTATION = gql`
  mutation UpdateOrganization($updateOrganizationId: ID!, $input: UpdateOrganizationInput!) {
    updateOrganization(id: $updateOrganizationId, input: $input) {
      organization {
        ...OrganizationFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ORGANIZATION_FRAGMENTS}
  ${MUTATION_ERROR_FRAGMENT}
`;

export const UPDATE_BUSINESS_MUTATION = gql`
  mutation UpdateBusiness($input: UpdateOrganizationInput!) {
    updateBusiness(input: $input) {
      organization {
        ...OrganizationFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ORGANIZATION_FRAGMENTS}
  ${MUTATION_ERROR_FRAGMENT}
`;

// TODO: When BE adds id as argument, update to:
// mutation UpdateBusiness($id: ID, $input: UpdateOrganizationInput!) {
//   updateBusiness(id: $id, input: $input) {

export const UPDATE_ORGANIZATION_PAYMENT_TYPE_MUTATION = gql`
  mutation UpdateOrganizationPaymentType($updateOrganizationPaymentTypeId: ID!, $input: UpdateOrganizationPaymentTypeInput!) {
    updateOrganizationPaymentType(id: $updateOrganizationPaymentTypeId, input: $input) {
      organizationPaymentType {
        id
        OrganizationId
        Enabled
        PaymentProviderPaymentTypeId
        Organization {
          id
        }
        PaymentProviderPaymentType {
          id
          name
          type
          enabled
        }
        PaymentContext
        CreatedAt
        UpdatedAt
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${MUTATION_ERROR_FRAGMENT}
`;
